<template>
  <div class="add-chapter">
    <WsAddChapterLayer2
      :fields="fields"
      :customParentData="$_getCustomParentData"
      :label="label"
      :modelName="modelName"
      :parentModelName="parentModelName"
      :parentVersionModelName="parentVersionModelName"
      :localeMode="localeMode"
      :editType="editType"
    ></WsAddChapterLayer2>
  </div>
</template>
<script>
import model from "@/models/audit_template";
import subModel from "@/models/audit_question_template";
export default {
  name: "AddChapterLayer",
  data: () => ({
    parentModelName: model.modelName,
    parentVersionModelName: model.versionModelName,
    modelName: subModel.modelName,
    localeMode: true,
    modelVersionName: subModel.modelVersionName,
    label: model.label,
    fields: subModel.fields,
    editType: "createVersion",
  }),
  methods: {
    $_getCustomParentData(templateData, templateVersionData) {
      const areas = templateData.areas.map(area => area.id)
      areas.push("2")
      return {...templateVersionData, areas}
    }
  }
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/add-chapter.scss";
</style>